module.exports = __webpack_public_path__ + "static/media/ArosaLenz_Tipp_2.8017960a.jpg";